import { Row, Col, Form, Button } from 'react-bootstrap'
import InputMask from 'react-input-mask'
import useFormStore from '../stores/useFormStore'

function Contato() {
  const { setField } = useFormStore()
  const { setError } = useFormStore()

  const validateField = useFormStore(state => state.validateField)

  return(
    <Row>
      <Col xs={12} sm={12} md={12} lg={12} className='text-center'>
        <h4>Contato</h4>
      </Col>
      <Col xs={12} sm={12} md={12} lg={6} className='text-center'>
        <p>
          Rua Araujo Leite, 2-25 - Centro - Bauru/SP
          <br/>
          Telefone: (14) 3232-4367
          <br/>
          E-mail: sindimetalurgicos@uol.com.br
        </p>
      </Col>
      <Col xs={12} sm={12} md={12} lg={6}>
        <Form>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Nome</Form.Label>
                <Form.Control
                  as={InputMask}
                  mask='9999'
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder=''
                  isInvalid='false'
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Fone</Form.Label>
                <Form.Control
                  as={InputMask}
                  mask='9999'
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder=''
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  as={InputMask}
                  mask='9999'
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder=''
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Assunto</Form.Label>
                <Form.Control
                  as={InputMask}
                  mask='9999'
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder=''
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Mensagem</Form.Label>
                <Form.Control
                  as="textarea"
                  ronws={4}
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder=''
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Button className='cor-primaria'>Enviar</Button>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  )
}

export default Contato